import axiosInstance from "../../../../api/AxiosInstance";
import { endpoints } from "../../../../services/endpoints";
import { getSupplierDetailRequest, getSupplierDetailRequestError, getSupplierDetailRequestSuccess } from "../../../slices/User/Detail/SupplierDetailSlice";

export const SupplierDetailApi = (id) => async (dispatch) => {

    const urlWithParams = `${endpoints.getSupplierDetail}/${id}`;
    try {
        dispatch(getSupplierDetailRequest());
        axiosInstance({
            method: "GET",
            url: urlWithParams,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
                return dispatch(getSupplierDetailRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(getSupplierDetailRequestError(_error));
            });
    } catch (error) {
    }
};
